export const DAILY_PROTEIN_SHORTFALL_MAX_PLAUSIBLE = 200

export function buildProteinAlertMessage(
  proteinShortfallG: number | null,
  currentHour: number,
): string | null {
  if (proteinShortfallG == null || proteinShortfallG <= 20) return null

  if (proteinShortfallG > DAILY_PROTEIN_SHORTFALL_MAX_PLAUSIBLE) {
    const timeHint =
      currentHour < 18
        ? 'Consider adding a high-protein snack this afternoon.'
        : 'Consider a high-protein snack before bed.'
    return `Protein tracking behind today — ${timeHint}`
  }

  return `${Math.round(proteinShortfallG)}g protein still to go today.`
}
